export type DebugExperimentToggle = {
  flagName: string;
  label: string;
};

/** LD flags exposed as Available/Control toggles in the Nubank debug menu. */
export const DEBUG_EXPERIMENT_TOGGLES: DebugExperimentToggle[] = [
  {
    flagName: "CommercePlatformNubankRollout",
    label: "Commerce WL redirect (hotels)",
  },
  {
    flagName: "CommercePlatformNubankFlightsRollout",
    label: "Commerce WL redirect for booking (flights)",
  },
  {
    flagName: "CommercePlatformNubankFlightsMyTripDetails",
    label: "Commerce WL redirect for my trips (flights)",
  },
  {
    flagName: "NubankCsatSurvey",
    label: "CSAT survey deeplink",
  },
  {
    flagName: "NubankExternalTrips",
    label: "External trips list (native back)",
  },
];
